import { WebLocale } from '@/enums/web-locale';

export const activeSubgenreCountries = ['US', 'GB', 'CA', 'AU', 'IN', 'DE', 'ES', 'FR', 'IT', 'BR'];
export const activeSubgenreCountriesWebLocales = [
	WebLocale.us,
	WebLocale.uk,
	WebLocale.ca,
	WebLocale.au,
	WebLocale.in,
	WebLocale.de,
	WebLocale.es,
	WebLocale.fr,
	WebLocale.it,
	WebLocale.br,
];
